"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../__index");
var _circleSolid = _interopRequireDefault(require("../../icons/circle-solid"));
var _exclamation = _interopRequireDefault(require("../../icons/exclamation"));
var _excluded = ["size"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var WarningBlackExclamation = function WarningBlackExclamation(_ref) {
  var size = _ref.size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, _extends({
    size: size
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_index.IconPath, {
    color: "var(--colorYellow)",
    path: _circleSolid["default"]
  }), /*#__PURE__*/_react["default"].createElement(_index.IconPath, {
    color: "var(--colorBlack)",
    path: _exclamation["default"]
  }));
};
var _default = exports["default"] = WarningBlackExclamation;